import React from "react";
import { View, StyleSheet } from "react-native";
import { useNavigation, type NavigationProp } from "@react-navigation/native";
import { QuestionLayout } from "@src/packages/medical-history/components";
import { useTranslations } from "@src/packages/i18n";
import { useSleepActivity } from "../SleepActivityContext";
import { RangeSlider } from "../components/RangeSlider";
import type { SleepActivityStackParamList } from "../SleepActivityNavigator";

const SLEEP_MIN = 5;
const SLEEP_MAX = 10;
const DEFAULT_MIN_SLEEP = 7;
const DEFAULT_MAX_SLEEP = 9;

export function SleepScreen() {
  const t = useTranslations();
  const { state, updateState } = useSleepActivity();
  const navigation =
    useNavigation<NavigationProp<SleepActivityStackParamList>>();

  const handleSave = () => {
    // Persist defaults if user didn't touch the slider
    if (state.minHoursOfSleep === null || state.maxHoursOfSleep === null) {
      updateState({
        minHoursOfSleep: DEFAULT_MIN_SLEEP,
        maxHoursOfSleep: DEFAULT_MAX_SLEEP,
      });
    }
    navigation.navigate("ActivityIntro");
  };

  return (
    <QuestionLayout
      title={t("med_history.lifestyle.sleep_activity.sleep_title")}
      subtitle={t("med_history.lifestyle.sleep_activity.sleep_subtitle")}
      onBack={() => navigation.goBack()}
      onSave={handleSave}
      saveDisabled={false}
      saveLabel={t("med_history.lifestyle.next")}
    >
      <View style={styles.container}>
        <RangeSlider
          min={SLEEP_MIN}
          max={SLEEP_MAX}
          lowValue={state.minHoursOfSleep ?? DEFAULT_MIN_SLEEP}
          highValue={state.maxHoursOfSleep ?? DEFAULT_MAX_SLEEP}
          onValuesChange={(low, high) =>
            updateState({ minHoursOfSleep: low, maxHoursOfSleep: high })
          }
          lowLabel="<5"
          highLabel=">10"
        />
      </View>
    </QuestionLayout>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    paddingHorizontal: 8,
    marginTop: 24,
    marginBottom: 40,
  },
});
